		<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="21"
						viewBox="0 0 20 21"
						fill="none"
					>
						<path
							d="M9.99996 18.8332C14.6023 18.8332 18.3333 15.1022 18.3333 10.4998C18.3333 5.89746 14.6023 2.1665 9.99996 2.1665C5.39759 2.1665 1.66663 5.89746 1.66663 10.4998C1.66663 15.1022 5.39759 18.8332 9.99996 18.8332Z"
							stroke="#0D6EFD"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M10 13.8333V10.5"
							stroke="#0D6EFD"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M10 7.1665H10.0083"
							stroke="#0D6EFD"
							stroke-width="2.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>